export const isZeroLeadingNumber = (val: string) => /^0(\d+|\.\d+)?$/.test(val)

/**
 * @deprecated Use Decimal from `@harvestiq/utils` instead.
 */
export const isDecimal = (val: string) => /^-?\d+\.?\d*$/.test(val)

export const isUnSignedDecimal = (val: string) =>
  /^0?([1-9]+\d*)?(\.\d{0,2})?$/.test(val)
